import AttributeInserter from '@intercom/embercom-composer/components/attribute-inserter';
export default AttributeInserter;
